export {
  ContextMarkAttendanceProvider,
  useContextMarkAttendance,
} from './context-mark-attendance';
